import { render, staticRenderFns } from "./assessmentReview.vue?vue&type=template&id=42f2e1c7&scoped=true"
import script from "./assessmentReview.vue?vue&type=script&lang=js"
export * from "./assessmentReview.vue?vue&type=script&lang=js"
import style0 from "./assessmentReview.vue?vue&type=style&index=0&id=42f2e1c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2e1c7",
  null
  
)

export default component.exports